import { AxiosError } from 'axios';

const getAxiosError = (error: AxiosError, defaultMessage = 'An error has occurred') => {
  const { response } = error;
  return response?.data?.error || defaultMessage;
};

export { getAxiosError };
